import React, { ReactNode } from 'react';

import NextLink from 'next/link';
import cm from '@/libs/tailwind-merge';

import { UrlObject } from 'url';
import { categorySlug } from '@/constants/categorySlug';
import { useCategories } from '@/contexts/profile';

// link danh mục: đổi mã (NHANNU) thành slug (nhan-nu) ở một chỗ cho mọi nơi dùng <Link>
const CATEGORY_PATHS = ['/danh-muc/[id]', '/danh-muc/[id]/[slug]'];
const prettyCategoryUrl = (url: string | UrlObject, categories?: any[] | null): string | UrlObject => {
  if (typeof url !== 'object' || !url || !CATEGORY_PATHS.includes(String(url.pathname))) return url;
  const q: any = url.query;
  if (!q || typeof q !== 'object' || !q.id) return url;
  return { ...url, query: { ...q, id: categorySlug(String(q.id), categories) } };
};

type LinkProps = {
  className?: string;
  url: string | UrlObject;
  children?: string | ReactNode;
  target?: string;
  title?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
};

export const Link = ({ children, url, className, target, title, disabled, style }: LinkProps) => {
  const categories = useCategories() as any[] | null;
  const cs = cm(
    'tw-text-primary-main hover:tw-text-primary-main visited:tw-text-primary-main tw-no-underline',
    className
  );

  return (
    <NextLink href={prettyCategoryUrl(url, categories)} passHref>
      <a target={target} title={title} className={cs} style={style}>
        {children}
      </a>
    </NextLink>
  );
};
